import * as React from "react"
import { StaticImage } from "gatsby-plugin-image"
import styled from "styled-components"
import Layout from "../components/layout"
import Seo from "../components/seo"
import Sidebar from "../components/Sidebar"
import ServiceInfoCard from "../components/serviceCard"
import BannerBG from "../images/service-bg.png"

const Banner = styled.section`
  background-image: url(${BannerBG});
  background-position: top;
  background-size: auto 100%;
  background-repeat: no-repeat;
  min-height: 60vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-end;
  text-align: center;

  h1 {
    font-size: ${props => props.theme.fontSize.h2};
  }
  h5 {
    width: 80%;
    margin: 0.5rem auto 2.5rem;
  }

  @media (min-width: 768px) {
    h1 {
      font-size: ${props => props.theme.fontSize.h1};
      margin-bottom: 1rem;
    }
    h5 {
      margin-bottom: 10vh;
    }
  }
  @media (min-width: 1024px) {
    min-height: 70vh;
    background-size: cover;
    h5 {
      width: 60%;
    }
  }
`

const SidebarSectionWrapper = styled.section`
  @media (min-width: 768px) {
  }
  @media (min-width: 1024px) {
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    justify-content: space-between;
    padding: 2rem 0;
    width: 90%;
    margin: 0 auto;
  }
`
const ServicesGrid = styled.div`
  @media (min-width: 768px) {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
  }
  @media (min-width: 1024px) {
  }
`
const OtherTreatments = styled.div`
  display: grid;
  padding: 2rem 0;
  h2 {
    text-align: center;
  }
  .gatsby-image-wrapper {
    margin: 1rem 0;
  }
  ul {
    list-style-type: circle inside;
    margin: 0 auto 0 2rem;
    width: 90%;
  }

  @media (min-width: 768px) {
    grid-template-areas: "title title" "image content";
    padding: 2rem;
    h2 {
      grid-area: title;
      margin-bottom: 1rem;
    }
    .gatsby-image-wrapper {
      grid-area: image;
    }
    .other-treatments-list {
      grid-area: content;
    }
  }
  @media (min-width: 1024px) {
    grid-template-areas: "image title" "image content";
    padding: 0;
    h2,
    .other-treatments-list {
      background: ${props => props.theme.colors.secondary};
      color: white;
    }
    h2 {
      margin-bottom: 0;
      padding: 1.2rem 0;
    }
    .other-treatments-list {
      padding: 0 0 1rem;
    }
    .gatsby-image-wrapper {
      width: 50vw;
    }
  }
`

const ServicesTemplate = ({ pageContext: { allServices } }) => (
  <Layout>
    <Seo title="Services" />
    <Banner>
      <h1>Quantum Services</h1>
      <h5>
        Quantum Functional Medicine is a center for health and rejuvenation.
      </h5>
    </Banner>

    <SidebarSectionWrapper>
      <ServicesGrid>
        {allServices.map(service => (
          <ServiceInfoCard key={service.name} service={service} />
        ))}
      </ServicesGrid>

      <Sidebar />
    </SidebarSectionWrapper>

    <OtherTreatments>
      <h2>Other Treatments</h2>

      <StaticImage
        src="../images/other-treatments.png"
        width={300}
        quality={95}
        formats={["AUTO", "WEBP", "AVIF"]}
        alt="Other Treatments"
        layout="constrained"
      />
      <div className="other-treatments-list">
        <ul>
          <li>Homotoxicology to restore the body’s immune defenses</li>
          <li>
            Prolo and Prolozone therapies to treat chronic joint injuries, back
            and neck problems
          </li>
          <li>
            Meso therapy to deliver medications into the layer beneath the skin,
            which then communicates with the deeper tissue, nerves, and
            lymphatics
          </li>
          <li>
            FirstLine Therapy® for improving and maintaining your health and
            addressing Metabolic Syndrome
          </li>
          <li>Individualized nutrition programs</li>
          <li>
            Laser treatments and Pulsed Electro-Magnetic Field therapy (PEMF)
          </li>
          <li>Asyra Testing</li>
        </ul>
      </div>
    </OtherTreatments>
  </Layout>
)

export default ServicesTemplate
